import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import * as locations from '../../../constants/dropdown';

import {messageTextValidation, nameValidation, emailValidation, phoneValidation, locationValidation} from '../../../utils/itemValidation';

import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

import RhinoSelect from '../../common/inputs/RhinoSelect';

class Contact extends React.Component {

  constructor(props) {
    super(props);

    const firstEntry = [{display: 'Location*', 'value': ''}];
    const finalEntry = [{display: 'Virtual/Other', 'value': 'online@diamondsdirect.com'}];

    let newArray= firstEntry.concat(locations.locations).concat(finalEntry);

    this.state = {
      locations: newArray,
      open: this.props.common.contactOpen,
      closing: false,
      inputName: '',
      inputEmail: '',
      inputPhone: '',
      inputLocation: '',
      inputMessage: '',
      errorName: null,
      errorEmail: null,
      errorPhone: null,
      errorLocation: null,
      errorMessage: null,
      scrollPos: 0,
    };

    this.getScrollPos = ::this.getScrollPos;
  }

  componentWillMount() {
    window.addEventListener('scroll', this.getScrollPos, false);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.getScrollPos, false);
  }

  getScrollPos() {
    this.setState({
      scrollPos: window.pageYOffset,
    })
  }

  openIntercom() {
    // acquireIO.max();
    acquireIO.max();
  }

  getContactClass() {
    let baseClass = this.state.scrollPos > 30 ? 'Contact scrolled ' : 'Contact ';
    if(this.state.closing) {
      return baseClass + 'closing';
    } else {
      return this.props.common.contactOpen ? baseClass + 'open' : baseClass + 'closed';
    }
  }

  getHeaderClass() {
    return this.state.scrollPos > 30 ? 'Header following' : 'Header';
  }

  closeContact() {
    this.setState({ closing: true });
    setTimeout(() => {
      this.setState({
        open: false,
        closing: false,
      }, () => {
        this.props.commonCloseContact();
      });
    }, 500)
  }

  catchClick(evt) {
    evt.stopPropagation();
  }

  changeName(evt) {
    this.setState({ inputName: evt.target.value }, () => {
      if(this.state.errorName && !nameValidation(this.state.inputName)) {
        this.setState({ errorName: null });
      }
    });
  }

  changeEmail(evt) {
    this.setState({ inputEmail: evt.target.value }, () => {
      if(this.state.errorEmail && !emailValidation(this.state.inputEmail)) {
        this.setState({ errorEmail: null });
      }
    });
  }

  changePhone(evt) {
    this.setState({ inputPhone: evt.target.value }, () => {
      if(this.state.errorPhone && !phoneValidation(this.state.inputPhone)) {
        this.setState({ errorPhone: null });
      }
    });
  }

  changeMessage(evt) {
    this.setState({ inputMessage: evt.target.value }, () => {
      if(this.state.errorMessage && !messageTextValidation(this.state.inputMessage)) {
        this.setState({ errorMessage: null });
      }
    });
  }

  validateAll() {
    let hasErrors = true;
    
    // Required params
    let nameError = nameValidation(this.state.inputName);
    let emailError = emailValidation(this.state.inputEmail);
    let messageError = messageTextValidation(this.state.inputMessage);
    let locationError = locationValidation(this.state.inputLocation);

    // Optional params
    let phoneError = null;
    if(this.state.inputPhone) {
      phoneError = phoneValidation(this.state.inputPhone);
    }

    if(nameError === null &&
       emailError === null &&
       phoneError === null &&
       locationError === null &&
       messageError === null) {
      hasErrors = false;
    }

    this.setState({
      errorName: nameError,
      errorEmail: emailError,
      errorPhone: phoneError,
      errorLocation: locationError,
      errorMessage: messageError
    });

    return !hasErrors;
  }

  submitContactRequest() {
    if(this.validateAll()) {

      let contactData = {
        full_name: this.state.inputName,
        email: this.state.inputEmail,
        phone: this.state.inputPhone,
        location: this.state.inputLocation,
        message: this.state.inputMessage,
      }

      this.props.commonContactRequest(contactData);
      // this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
      this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly to finalize your virtual appointment.', 'Continue Browsing', 'helping', '');
      this.setState({
        inputName: '',
        inputEmail: '',
        inputPhone: '',
        inputLocation: '',
        inputMessage: '',
        errorName: null,
        errorEmail: null,
        errorPhone: null,
        errorLocation: null,
        errorMessage: null,
      });
      this.props.commonCloseContact();
    }
  }

  // Formerly used with City/State Dropdown
  selectLocation(evt) {
    this.setState({inputLocation: evt.target.value}, () => {
      if(this.state.errorLocation !== false && location !== '') {
        this.setState({errorLocation: null});
      }
    });
  }  


  render() {
    return <div className={::this.getContactClass()} onClick={::this.closeContact}>
      <div className='contactBody' onClick={::this.catchClick}>
        <div className='closeContact' onClick={::this.closeContact}>
          <div className='closeX'>&times;</div>
        </div>
        <div className='formWrapper'>
          <div className='formLogo'>
            <LazyLoadImage src='https://ddw2.diamondsdirect.com/img/menu/ddlogowhite.svg' alt='Diamonds Direct' />
          </div>
          <div className='formBody'>
            <div className='formTitle' style={{display: 'none'}}>We'd love to hear from you!</div>
            
            <div className='formText'>Our experts are standing by to help you!</div>
            <div className='formText'>Please fill out the form below to request a virtual or in-store appointment and a member of our team will be in touch with you as soon as possible!</div>

            <div className='formRow'>
              <input 
                className={this.state.errorName ? 'textInput error' : 'textInput'}
                type='text' 
                placeholder='Full Name&#42;'
                value={this.state.inputName}
                onChange={::this.changeName} />
              <input 
                className={this.state.errorEmail ? 'textInput error' : 'textInput'}
                type='email' 
                placeholder='Email Address&#42;'
                value={this.state.inputEmail}
                onChange={::this.changeEmail} />
            </div>
            <div className='formRow'>
              <input 
                className={this.state.errorPhone ? 'textInput error' : 'textInput'}
                type='text' 
                placeholder='Telephone'
                value={this.state.inputPhone}
                onChange={::this.changePhone} />
              <RhinoSelect
                selectClass={'contactSelect'}
                required={true}
                value={this.state.inputLocation}
                options={this.state.locations}
                changeMethod={(evt) => this.selectLocation(evt)}
                error={this.state.errorLocation} />
            </div>
            <div className='formRow'>
              <textarea
                className={this.state.errorMessage ? 'textTextarea error' : 'textTextarea'}
                placeholder='How can we help you?'
                value={this.state.inputMessage}
                onChange={::this.changeMessage}>
              </textarea>
            </div>
            <div className='formRow'>
              <div 
                className={'contactSubmit secondaryButton'}
                onClick={::this.submitContactRequest}>Submit</div>
            </div>
            <div className='formText' style={{marginTop: '15px'}}>We look forward to assisting you!</div>
          </div>
          
          <div className='phonePrompt' style={{display: 'none'}}>
            Call Us: <a href='tel:8008855050'>(800) 885.5050</a>
          </div>
          <div className={'chatButton actionButton iconButton'} onClick={::this.openIntercom} style={{display: 'none'}}>
            <div className='buttonIcon'>
              <LazyLoadImage src='https://ddw2.diamondsdirect.com/img/icons/chat-white.svg' />
            </div>
            Chat with Us
          </div>
        </div>
      </div>
    </div>
  }
}
export default Contact;

function mapStateToProps(state) {
  return {
    common: state.common
  };
}

export const ContactContainer = connect(
  mapStateToProps,
  allActionCreators
)(Contact);


// WEBPACK FOOTER //
// ./src/components/views/contact/Contact.jsx